module.exports = __webpack_public_path__ + "static/media/deactive_image_icon.449e7eaf.svg";